import type { StatusBadgeProps } from "@/components/ds/StatusBadge";

type Tone = NonNullable<StatusBadgeProps["tone"]>;

// Receptionist lifecycle → label + tone.
export const RECEPTIONIST_STATUS: Record<string, { label: string; tone: Tone }> = {
  draft: { label: "Draft", tone: "slate" },
  testing: { label: "Testing", tone: "amber" },
  active: { label: "Active", tone: "green" },
  paused: { label: "Paused", tone: "amber" },
  needs_attention: { label: "Needs attention", tone: "red" },
};

// Human-friendly audit action labels for the activity feed.
export const ACTIVITY_LABELS: Record<string, string> = {
  "onboarding.business_profile": "Updated business profile",
  "onboarding.completed": "Completed onboarding setup",
  "organization.updated": "Updated organization settings",
  "profile.updated": "Updated profile",
  "member.invited": "Invited a team member",
};

export function humanizeActivity(action: string): string {
  return ACTIVITY_LABELS[action] ?? action.replace(/[._]/g, " ").replace(/^\w/, (c) => c.toUpperCase());
}

export function timeAgo(iso?: string): string {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const secs = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (secs < 60) return "just now";
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}
